﻿<script setup lang="ts">
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import intlTelInput from 'intl-tel-input';
    import 'intl-tel-input/build/css/intlTelInput.css';

    const props = defineProps<{
        modelValue: string | null;
        label: string;
        placeholder?: string;
        type?: 'text' | 'tel';
        infoText?: string;
        glyph?: string;
        options?: any;
    }>();

    const emit = defineEmits(['update:modelValue']);
    const initIntlTelInput = (input: HTMLElement) => {
        intlTelInput(input, props.options || {});

        input.addEventListener('countrychange', (event: any) => {
            emit('update:modelValue', event.target.value);
        });
    };
</script>

<script lang="ts"></script>

<template>
    <div>
        <BSFormInputText
            ref="el"
            :modelValue="props.modelValue"
            @mountedInputEl="initIntlTelInput"
            @update:modelValue="(newValue: string) => $emit('update:modelValue', newValue)"
            :label="props.label"
            :infoText="props.infoText"></BSFormInputText>
    </div>
</template>

<style scoped></style>

<style>
    .iti {
        width: 100%;
    }
</style>
